import React from 'react';
import moment from 'moment';

interface OwnProps {
    dayOfWeek: number;
    format?: string;
}

type Props = OwnProps;

export class DayOfWeekDate extends React.PureComponent<Props> {
    render(): string | null {
        const { dayOfWeek, format } = this.props;
        // Make the week start on monday
        const adjustedDayOfWeek = dayOfWeek === 6 ? 0 : dayOfWeek + 1;
        return moment(adjustedDayOfWeek, 'd').format(format || 'dddd');
    }
}

export default DayOfWeekDate;
